export function makeInflect<T extends string = string>(singular: T, plural: T, rest: T) {
	return function (count: number): T {
		if (count === 1) {
			return singular;
		} else if (count >= 2 && count <= 4) {
			return plural;
		} else {
			return rest;
		}
	};
}
